// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "5" ? "transactions" : chunkId) + "." + {"1": "c9b032f4a68fdd9a","5": "b732d2feb4d84578",}[chunkId] + ".chunk.css"
}